<template>
  <section id="breadcrumb">
    <div class="demo">
      <nav aria-label="Breadcrumb" role="navigation">
          <ol class="breadcrumb">
              <li>
              <a href="#" aria-label="home">
                  <i class="gel-icon-home"></i>
              </a>
              </li>
              <li>
              <a href="#">level 2</a>
              </li>
              <li>
              <a href="#">level 3</a>
              </li>
              <li class="active" aria-current="page">Current</li>
          </ol>
      </nav>
    </div>
    <section class="md" v-html="mdfile"></section>
  </section>
</template>

<script>
import mdfile from "@/docs/components/breadcrumb.md";
export default {
  name: "breadcrumb",
  beforeCreate: function () {
    this.$emit("update-title", this.$root.yamlData.components.breadcrumb.name);
    this.$emit("update-tagline", this.$root.yamlData.components.breadcrumb.description);
  },
  data() {
    return {
      mdfile
    };
  }
};
</script>
